(function () {
    'use strict';

    angular
        .module('gov.filters')
        .filter('t', ['languageService', function (languageService) {

            var translations = {
                // --- Disruption Impacts ---
                'Disruption Impacts': 'Impacts de perturbation',
                'No Disruption Impacts': 'Aucun impact de perturbation',
                'Financial': 'Financier',
                'Operational/Reputational': 'Opérationnel / Réputationnel',
                'Compliance': 'Conformité',
                'Overall Impact': 'Impact global',
                'Yes': 'Oui',
                'No': 'Non',
                'Comment': 'Commentaire',
                'Please explain your reasoning or refer to precedents': 'Veuillez expliquer votre raisonnement ou vous référer à des précédents',
                'Please assess disruption impacts if the said business responsibility was interrupted for one week during the worst operational conditions (i.e. peak period, market volatility, etc.)':
                    'Veuillez évaluer les impacts de perturbation si la responsabilité d\'affaires était interrompue pendant une semaine dans les pires conditions opérationnelles (période de pointe, volatilité des marchés, etc.)',
                'Please provide all required fields': 'Veuillez remplir tous les champs requis',

                // --- Responsibility Execution ---
                'Business Responsibility Execution': 'Exécution de la responsabilité d\'affaires',
                'Responsibility Execution': 'Exécution de la responsabilité',
                'Responsibility Timeframe': 'Horaire de la responsabilité',
                'Responsibility Execution Timeframe': 'Horaire d\'exécution de la responsabilité',
                'No Information': 'Aucune information',
                'Custom': 'Personnalisé',
                '24/7': '24/7',
                'From': 'De',
                'to': 'à',
                'Until': 'Jusqu\'à',
                'until': 'jusqu\'à',
                'Every': 'Chaque',
                'Overtime:': 'Heures supplémentaires :',
                'Overtime': 'Heures supplémentaires',
                'Performed during Public Holidays:': 'Effectué pendant les jours fériés :',
                'Performed during public holidays': 'Effectué pendant les jours fériés',
                'Days': 'Jours',
                '(either can be left blank)': '(l\'un ou l\'autre peut être laissé vide)',
                '(choose none to many)': '(choisir aucun ou plusieurs)',

                // --- Execution Plan Fields ---
                'Operational Workaround': 'Solution de contournement opérationnelle',
                'Critical Period': 'Période critique',
                'Off-site Execution': 'Exécution hors site',
                'Key Inputs': 'Intrants clés',

                // --- Key Staff / Systems / Special Needs ---
                'Key Staff': 'Personnel clé',
                'No Key Staff': 'Aucun personnel clé',
                'Key Systems': 'Systèmes clés',
                'No Key Systems': 'Aucun système clé',
                'Special Needs': 'Besoins spéciaux',
                'No Special Needs': 'Aucun besoin spécial',
                'Please identify special needs (e.g. Bloomberg keyboard, scanner, cheque printer, etc.)':
                    'Veuillez identifier les besoins spéciaux (ex. clavier Bloomberg, numériseur, imprimante de chèques, etc.)',

                // --- BIA Profile ---
                'Delete this BC Analysis?': 'Supprimer cette analyse de continuité?',
                'Continuity Owner': 'Responsable de la continuité',
                'Continuity Owners': 'Responsables de la continuité',
                'No Continuity Owner': 'Aucun responsable de la continuité',
                'Please identify the business heads related to this BIA profile.':
                    'Veuillez identifier les responsables d\'affaires liés à ce profil d\'ACA.',
                'Validation': 'Validation',
                'The Business Continuity Analysis is ready to be validated':
                    'L\'analyse de continuité des affaires est prête à être validée',
                'You have validated this Business Continuity Analysis':
                    'Vous avez validé cette analyse de continuité des affaires',
                'Pending validation by all Business Heads':
                    'En attente de validation par tous les responsables d\'affaires',
                'Reset Validations': 'Réinitialiser les validations',

                // --- Continuity Coordinators ---
                'Continuity Coordinators': 'Coordonnateurs de la continuité',
                'No Continuity Coordinators': 'Aucun coordonnateur de la continuité',
                'Pending Approval': 'En attente d\'approbation',
                'BC Analysis Approved': 'Analyse de continuité approuvée',
                'coordinators': 'coordonnateurs',
                'related to this BIA profile.': 'liés à ce profil d\'ACA.',

                // --- BU Owner ---
                'Business Responsibilities and Continuity Priorities': 'Responsabilités d\'affaires et priorités de continuité',
                'Business Responsibilities': 'Responsabilités d\'affaires',
                'Delete this Continuity Owner?': 'Supprimer ce responsable de la continuité?',
                'Deleting this Continuity Owner will delete his/her business responsibilities.':
                    'La suppression de ce responsable de la continuité supprimera ses responsabilités d\'affaires.',

                // --- Summary / Validation ---
                'BC Analysis Summary': 'Résumé de l\'analyse de continuité',
                'Pending': 'En attente',
                'Approved': 'Approuvé',
                'Reject': 'Rejeter',
                'Validate': 'Valider',
                'Cancel': 'Annuler',
                'Save': 'Enregistrer',
                'Discard Changes': 'Annuler les modifications',

                // --- Banners ---
                'View All': 'Voir tout',
                'Prioritize': 'Prioriser',
                'Responsibilities are ready to be prioritized': 'Les responsabilités sont prêtes à être priorisées',
                'Not Prioritized': 'Non priorisé',

                // --- Introduction Page ---
                'Business Continuity Analysis': 'Analyse de continuité des affaires',
                'Requirement': 'Exigence',
                'Outcomes': 'Résultats',
                'Assumptions': 'Hypothèses',
                'Begin': 'Commencer',

                // --- Validation Modal ---
                'Validate Business Continuity Analysis': 'Valider l\'analyse de continuité des affaires',
                'Once validated, the BC Analysis will not be editable anymore.':
                    'Une fois validée, l\'analyse de continuité ne sera plus modifiable.',

                // --- Breadcrumbs ---
                'Help': 'Aide',

                // --- Banners (dynamic) ---
                'There is 1 more responsibility available for assessment': 'Il reste 1 responsabilité à évaluer',

                // --- Tooltips ---
                'Designated business unit representative responsible for coordinating business continuity activities \u2013 planning and execution':
                    'Repr\u00e9sentant d\u00e9sign\u00e9 de l\u2019unit\u00e9 d\u2019affaires responsable de la coordination des activit\u00e9s de continuit\u00e9 des affaires \u2013 planification et ex\u00e9cution',
                'Business unit representative responsible for coordinating business continuity activities for its business unit':
                    'Repr\u00e9sentant de l\u2019unit\u00e9 d\u2019affaires responsable de la coordination des activit\u00e9s de continuit\u00e9 des affaires pour son unit\u00e9 d\u2019affaires',
                'Urgency for resuming a business responsibility or process following a disruption':
                    'Urgence de reprendre une responsabilit\u00e9 ou un processus d\u2019affaires \u00e0 la suite d\u2019une perturbation',
                'Business unit head accountable for the business continuity of his/her operations':
                    'Responsable de l\u2019unit\u00e9 d\u2019affaires responsable de la continuit\u00e9 des affaires de ses op\u00e9rations',
                'Busiest time, volume peak, lack of staff or deadline for the said business responsibility':
                    'P\u00e9riode la plus charg\u00e9e, pic de volume, manque de personnel ou date limite pour la responsabilit\u00e9 d\u2019affaires concern\u00e9e',
                'Edit Impacts': '\u00c9diter les impacts',
                'Edit Info': '\u00c9diter les informations',
                'Edit info': '\u00c9diter les informations',
                'Set continuity priorities': 'D\u00e9finir les priorit\u00e9s de continuit\u00e9',
                'Select business responsibilities': 'S\u00e9lectionner les responsabilit\u00e9s d\u2019affaires',
                'Show Help': 'Afficher l\u2019aide',
                'Reset Business Continuity Analysis Validations': 'R\u00e9initialiser les validations de l\u2019analyse de continuit\u00e9 des affaires',
                'BC Analysis': 'Analyse de continuit\u00e9',
                'Business Unit': 'Unit\u00e9 d\u2019affaires',
                'Responsibility': 'Responsabilit\u00e9',
                'BCM Responsibility': 'Responsabilit\u00e9 GCA',
                'Plan Initiative': 'Initiative du plan',
                'Business Unit representative responsible for coordinating business continuity activities for its business unit':
                    'Repr\u00e9sentant de l\u2019unit\u00e9 d\u2019affaires responsable de la coordination des activit\u00e9s de continuit\u00e9 des affaires pour son unit\u00e9 d\u2019affaires',

                // --- BCM/BIA Template Translations ---
                'Close': 'Fermer',
                'Title *': 'Titre *',
                'Title': 'Titre',
                'Description': 'Description',
                'Description *': 'Description *',
                'Add BCM Responsibility': 'Ajouter une responsabilit\u00e9 GCA',
                'New': 'Nouveau',
                'BCM': 'GCA',
                'Add': 'Ajouter',
                'Add a responsibility': 'Ajouter une responsabilit\u00e9',
                'Select Business Responsibilities': 'S\u00e9lectionner les responsabilit\u00e9s d\'affaires',
                'Default list from corporate procedures': 'Liste par d\u00e9faut des proc\u00e9dures corporatives',
                'Selected Business Responsibilities': 'Responsabilit\u00e9s d\'affaires s\u00e9lectionn\u00e9es',
                'There are 0 business responsibilities selected': 'Il y a 0 responsabilit\u00e9 d\'affaires s\u00e9lectionn\u00e9e',
                'There is 1 business responsibility selected': 'Il y a 1 responsabilit\u00e9 d\'affaires s\u00e9lectionn\u00e9e',
                'responsibilities selected': 'responsabilit\u00e9s s\u00e9lectionn\u00e9es',
                'Please select continuity priorities': 'Veuillez s\u00e9lectionner les priorit\u00e9s de continuit\u00e9',
                'Impact Level': 'Niveau d\'impact',
                'Disruption Impacts Comments': 'Commentaires sur les impacts de perturbation',
                'Financial:': 'Financier :',
                'Operational/Reputational:': 'Op\u00e9rationnel/R\u00e9putationnel :',
                'Compliance:': 'Conformit\u00e9 :',
                'No Responsibilities assigned with that level of priority': 'Aucune responsabilit\u00e9 assign\u00e9e \u00e0 ce niveau de priorit\u00e9',
                'View Analysis': 'Voir l\'analyse',
                'Completed': 'Compl\u00e9t\u00e9',
                'Back to': 'Retour \u00e0',
                'BIA Owner': 'Responsable ACA',
                'Add a Business Continuity Analysis': 'Ajouter une analyse de continuit\u00e9 des affaires',
                'Please edit a title': 'Veuillez saisir un titre',
                'Please edit a description...': 'Veuillez saisir une description...',
                'Please provide a Title...': 'Veuillez fournir un titre...',
                'Please provide a description...': 'Veuillez fournir une description...',
                'Edit Title and Description': 'Modifier le titre et la description',
                'Identify Continuity Owner': 'Identifier le responsable de la continuit\u00e9',
                'Search by person or business unit \u2026': 'Rechercher par personne ou unit\u00e9 d\'affaires \u2026',
                'Selected Continuity Owner': 'Responsable de la continuit\u00e9 s\u00e9lectionn\u00e9',
                'is 0 Continuity Owner selected': '0 responsable de la continuit\u00e9 s\u00e9lectionn\u00e9',
                'is 1 Continuity Owner selected': '1 responsable de la continuit\u00e9 s\u00e9lectionn\u00e9',
                'Continuity Owners selected': 'responsables de la continuit\u00e9 s\u00e9lectionn\u00e9s',
                'Identify Continuity Coordinators': 'Identifier les coordonnateurs de la continuit\u00e9',
                'Search by person ...': 'Rechercher par personne ...',
                'Selected': 'S\u00e9lectionn\u00e9s',
                'are 0 Continuity Coordinators selected': '0 coordonnateur de la continuit\u00e9 s\u00e9lectionn\u00e9',
                'is 1 Continuity Coordinator selected': '1 coordonnateur de la continuit\u00e9 s\u00e9lectionn\u00e9',
                'Continuity Coordinators selected': 'coordonnateurs de la continuit\u00e9 s\u00e9lectionn\u00e9s',
                'Reject BCA': 'Rejeter l\'ACA',
                'Comments': 'Commentaires',
                'Define Role': 'D\u00e9finir le r\u00f4le',
                'Identify Key Systems': 'Identifier les syst\u00e8mes cl\u00e9s',
                'Systems Registry': 'Registre des systèmes',
                'systems available': 'systèmes disponibles',
                'Selected Key Systems': 'Systèmes clés sélectionnés',
                'systems selected': 'systèmes sélectionnés',
                'Edit Responsibility': 'Modifier la responsabilit\u00e9',
                'Business Responsibility': 'Responsabilit\u00e9 d\'affaires',
                'Identify Key Staff': 'Identifier le personnel cl\u00e9',
                'Search by person or business unit name ...': 'Rechercher par personne ou nom d\'unit\u00e9 d\'affaires ...',
                'Selected Key Staff': 'Personnel cl\u00e9 s\u00e9lectionn\u00e9',
                'key staff selected': 'personnel cl\u00e9 s\u00e9lectionn\u00e9',
                'Remove': 'Retirer',
                'Set Continuity Priorities': 'D\u00e9finir les priorit\u00e9s de continuit\u00e9',
                'Prioritized': 'Prioris\u00e9',
                'Responsibilities Left To Rate': 'Responsabilit\u00e9s restantes \u00e0 \u00e9valuer',
                'Choose Key Staff Role': 'Choisir le r\u00f4le du personnel cl\u00e9',
                'Key Signing Authority': 'Autorit\u00e9 de signature cl\u00e9',
                'Please edit the title for this continuity Priority': 'Veuillez modifier le titre de cette priorit\u00e9 de continuit\u00e9',
                'ex: From January to august, every first Monday of the month': 'ex: De janvier \u00e0 ao\u00fbt, chaque premier lundi du mois',
                'Please edit ...': 'Veuillez modifier ...',
                'Please assess ...': 'Veuillez \u00e9valuer ...',
                'Please provide ...': 'Veuillez fournir ...',
                'Please identify ...': 'Veuillez identifier ...',
                'This will reset the validation status for Business Continuity Coordinators and Heads and cannot be reverted.':
                    'Ceci r\u00e9initialisera le statut de validation des coordonnateurs et des responsables de la continuit\u00e9 des affaires et ne peut pas \u00eatre annul\u00e9.',

                // --- Recovery Metrics ---
                'Recovery Metrics': 'Indicateurs de r\u00e9tablissement',
                'No Recovery Metrics': 'Aucun indicateur de r\u00e9tablissement',
                'Edit Recovery Metrics': '\u00c9diter les indicateurs de r\u00e9tablissement',
                'MTPD Expert': 'DMIA Expert',
                'MTPD Calculated': 'DMIA Calcul\u00e9',
                'Delta': '\u00c9cart',
                'MBCO': 'ONME',
                'Linked Systems Recovery': 'R\u00e9tablissement des syst\u00e8mes li\u00e9s',
                'System': 'Syst\u00e8me',
                'RTO': 'OTR',
                'RPO': 'OPR',
                'Gap Check': 'V\u00e9rification d\'\u00e9cart',
                'Hours': 'Heures',
                'Minutes': 'Minutes',
                'Justification': 'Justification',
                'Source': 'Source',

                // --- Resource Requirements ---
                'Resource Requirements': 'Besoins en ressources',
                'No Resource Requirements': 'Aucun besoin en ressources',
                'Edit Resource Requirements': '\u00c9diter les besoins en ressources',
                'Minimum Staff (Normal)': 'Personnel minimum (normal)',
                'Minimum Staff (Degraded)': 'Personnel minimum (d\u00e9grad\u00e9)',
                'Primary Location': 'Emplacement principal',
                'Fallback Location': 'Emplacement de repli',
                'Equipment & Special Needs': '\u00c9quipement et besoins sp\u00e9ciaux',
                'Select': 'S\u00e9lectionner',
                'None': 'Aucun',
                'No locations available': 'Aucun emplacement disponible',

                // --- Activity / Process ---
                'Activity / Process': 'Activité / Processus',
                'No Activity / Process': 'Aucune activité / processus',
                'No processes selected': 'Aucun processus sélectionné',
                'Activity / Process Saved Successfully': 'Activité / Processus enregistré avec succès',
                'Search ...': 'Rechercher ...',
                'Selected': 'Sélectionnés',

                // --- Dependencies ---
                'Dependencies': 'D\u00e9pendances',
                'No Dependencies': 'Aucune d\u00e9pendance',
                'Add Dependency': 'Ajouter une d\u00e9pendance',
                'Edit Dependency': 'Modifier la d\u00e9pendance',
                'Dependency Type': 'Type de dépendance',
                'Name': 'Nom',
                'Notes': 'Notes',
                'Edit': 'Modifier',

                // --- Suggested Impact ---
                'Suggested': 'Suggéré',
                'active dimensions': 'dimensions actives',
                'Impact Level': 'Niveau d\'impact',
                'Not Rated': 'Non évalué',

                // --- Criticality View ---
                'Criticality View': 'Vue de criticité',
                'Details': 'Détails',
                'No data available for criticality view': 'Aucune donnée disponible pour la vue de criticité',
                'Impact Dimensions': 'Dimensions d\'impact',
                'Priority Distribution': 'Distribution des priorités',
                'MTPD Distribution': 'Distribution DMIA',
                'Dependency Heatmap': 'Carte thermique des dépendances',

                // --- Misc ---
                'NA': 'S/O',
                'Delete': 'Supprimer',
                'Delete this responsibility?': 'Supprimer cette responsabilité?',
                'Deleting this responsibility will delete its key staff.':
                    'La suppression de cette responsabilité supprimera son personnel clé.'
            };

            function translateFilter(key) {
                var lang = languageService.getCurrentLanguage().id;
                if (lang === 'fr' && Object.prototype.hasOwnProperty.call(translations, key)) {
                    return translations[key];
                }
                return key;
            }

            // Mark as stateless - language only changes on page reload
            translateFilter.$stateful = false;

            return translateFilter;
        }]);
})();
